// extracted by mini-css-extract-plugin
export default {"container":"Title_container__iWC1F","TitleWrapper":"Title_TitleWrapper__7h399","Main":"Title_Main__+9Lj9","Title":"Title_Title__VYbTs","Number":"Title_Number__HhsGR"};